'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _middleware = require('../../middleware');

var _paths = require('./paths');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

exports.default = function (feis_id, event_id) {
  return function (dispatch) {
    return dispatch(_defineProperty({
      feis_id: feis_id,
      event_id: event_id

    }, _middleware.CALL_API, {
      config: {
        url: (0, _paths.feisEventsPrefix)(feis_id) + '/' + event_id + '/group-fee',
        method: 'DELETE'
      },
      types: ['DELETE_GROUP_FEE_ASSIGNED_TO_EVENT_START', 'DELETE_GROUP_FEE_ASSIGNED_TO_EVENT', 'DELETE_GROUP_FEE_ASSIGNED_TO_EVENT_ERROR']
    }));
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/events/deleteGroupFeeAssignedToEvent.js
// module id = 633
// module chunks = 0